module.exports = __webpack_public_path__ + "static/HKGrotesk-Light-d9cb79cf87375a955fea4ed0a7ffd8ce.woff2";